import React, { DragEvent, DragEventHandler, PropsWithChildren, useState } from 'react';
import { connect } from 'react-redux';
import { DropArea } from '@ff-os/shared-react/components/file-uploader/DropArea';
import { createFileUploaderRef, UploadError } from '@ff-os/shared-react/components/file-uploader/FileUploader';
import { WindowStackItem } from '@ff-os/shared-react/context/window-stack/WindowStackItem';
import { maximumImageSize } from '@ff-os/shared-utils/constants/maximum-file-sizes';
import { PhotoPrintsPdpDispatch } from '@ff-scene-plugins/photo-prints-redux/store';
import { uploadImages } from '../../thunks/uploadImages';
import { ChangeVariantWindow } from '../change-variant-window/ChangeVariantWindow';
import styles from './PhotoPrintsDropzone.module.scss';

const _PhotoPrintsDropzone = ({ children, uploadFilesInto, setUploadErrors }: OwnProps & Props) => {

    const [isVariantModalOpen, setVariantModalOpen] = useState(false);
    const [isCreateGroupOpen, setIsCreateGroupOpen] = useState(false);
    const [files, setFiles] = useState<File[]>([]);

    const [photoId, setPhotoId] = useState<string | null>(null);

    const isMovingFiles = (event: DragEvent<Element>) => {
        return event.dataTransfer.items[0]?.kind === 'file';
    };

    const uploaderRef = createFileUploaderRef();

    const onDrop: DragEventHandler = (event) => {
        event.preventDefault();

        if (!isMovingFiles(event)) {
            const photoId = event.dataTransfer.getData('photoId');
            if (photoId) {
                setPhotoId(photoId);
                setVariantModalOpen(true);
            }
        } else {
            setIsCreateGroupOpen(true);
        }
    };

    return (
        <>
            <DropArea
                className={styles.default}
                onDrop={onDrop}
                ref={uploaderRef}
                maxSize={maximumImageSize}
                multiple={true}
                onError={errors => setUploadErrors(errors.filter(e => e.type === 'file'))}
                onChange={setFiles}>

                {children}
            </DropArea>

            {isVariantModalOpen && photoId && (
                <WindowStackItem>
                    <ChangeVariantWindow withMethod forceNewGroup
                        close={() => setVariantModalOpen(false)}
                        photoId={photoId} />
                </WindowStackItem>
            )}

            {isCreateGroupOpen && (
                <WindowStackItem>
                    <ChangeVariantWindow
                        title='photo_prints.extra_group'
                        close={() => setIsCreateGroupOpen(false)}
                        onSave={({ groupId }) => uploadFilesInto(groupId, files)} />
                </WindowStackItem>
            )}
        </>
    );
};

type OwnProps = PropsWithChildren<{
    setUploadErrors: (errors: UploadError[]) => void;
}>;

type Props = {
    uploadFilesInto: (groupId: string, files: File[]) => void;
};

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch: PhotoPrintsPdpDispatch, _: OwnProps) => ({
    uploadFilesInto: (groupId: string, files: File[]) => dispatch(uploadImages(files, groupId))
});

export const PhotoPrintsDropzone = connect(
    mapStateToProps,
    mapDispatchToProps
)(_PhotoPrintsDropzone);